import NavBar from 'components/pageLevel/NavBar';
import React, { useEffect, useState } from 'react';
import { sess_delete, sess_get, sess_post, sess_put } from 'utils/HttpRequests';
import moment from 'moment';
import { FiEdit2 } from 'react-icons/fi';
import { AiFillDelete } from 'react-icons/ai';
import Popup from 'reactjs-popup';
const contentStyle = { width: '700px' };


export function EditPopup(props) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [type, setType] = useState('');
  const [body, setBody] = useState('');

  useEffect(() => {
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    setBody('');
    setType('');
    sess_get(`admin/console/template/sms/${props.id}`, session_token)
      .then(res => { setBody(res?.data?.response?.sms_body); setType(res?.data?.response?.sms_type) })
      .catch(err => console.log(err));
  }, [props.open])

  const onSubmit = () => {
    if (submitting) return;
    setSubmitting(true);
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    sess_put(`admin/console/template/sms/${props.id}`, session_token, { sms_body: body, sms_type: type })
      .then(res => { setSubmitting(false); setError(''); setBody(''); setType(''); props.close(); })
      .catch(err => {
        setError(err?.response?.data?.error?.reason);
        setSubmitting(false)
      })
  }

  return <Popup open={props.open} closeOnDocumentClick={false} closeOnEscape={false} {...{ contentStyle }}>
    <div style={{ borderRadius: '6px' }}>
      <h2>Edit</h2>
      <hr />
      <label>SMS Type</label>
      <input
        style={{ width: '-webkit-fill-available' }}
        value={type || ''}
        disabled={true}
      />
      <br />
      <label>SMS Body</label>
      <textarea
        style={{ width: '-webkit-fill-available' }}
        rows={5}
        value={body}
        onChange={(e) => { setBody(e.target.value) }}
      />
      <hr />
      <p style={{ color: 'red' }}>{error}</p>
      <div style={{ textAlign: 'right', margin: '10px' }}>
        <button className="btn btn-primary" style={{ marginRight: '10px' }} onClick={onSubmit}>Save</button>
        <button className="btn btn-primary" onClick={() => { setError(''); props.close(); }} >Cancel</button>
      </div>
    </div>
  </Popup>
}

export function CreatePopup(props) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [type, setType] = useState('');
  const [body, setBody] = useState('');

  const onSubmit = () => {
    if (submitting) return;
    setSubmitting(true);
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    sess_post('admin/console/template/sms', session_token, { sms_body: body, sms_type: type })
      .then(err => { setSubmitting(false); setError(''); props.close(); })
      .catch(err => { setError(err?.response?.data?.error?.reason); setSubmitting(false) })
  }

  return <Popup open={props.open} closeOnDocumentClick={false} closeOnEscape={false} {...{ contentStyle }}>
    <div >
      <h2>Create</h2>
      <hr />
      <label>SMS Type</label>
      <input
        style={{ width: '-webkit-fill-available' }}
        value={type}
        onChange={(e) => setType(e.target.value)}

      />
      <br />
      <label>SMS Body</label>
      <textarea
        style={{ width: '-webkit-fill-available' }}
        rows={5}
        value={body}
        onChange={(e) => setBody(e.target.value)}
      />
      <p style={{ color: 'red' }}>{error}</p>
      <hr />
      <div style={{ textAlign: 'right', margin: '10px' }}>
        <button className="btn btn-primary" style={{ marginRight: '10px' }} onClick={onSubmit}>Save</button>
        <button className="btn btn-primary" onClick={() => { setError(''); props.close(); }}>Cancel</button>
      </div>
    </div>
  </Popup>
}
export function DeletePopup(props) {

  const onDelete = () => {
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    sess_delete(`admin/console/template/sms/${props.id}`, session_token)
      .then(res => (props.close()))
      .catch(err => console.log(err));
  }

  return <Popup open={props.open} closeOnDocumentClick={false} closeOnEscape={false} {...{ contentStyle }}>
    <div >
      <h2>Delete SMS Template</h2>
      <hr />
      <p>Are you sure you want to delete SMS template {props.id}</p>
      <hr />
      <div style={{ textAlign: 'right', margin: '10px' }}>
        <button className="btn btn-primary" style={{ marginRight: '10px' }} onClick={onDelete}>Delete</button>
        <button className="btn btn-primary" onClick={props.close}>Cancel</button>
      </div>
    </div>
  </Popup>
}



export default function SMSOps() {
  const [data, setData] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [isCreatePopupOpen, setIsCreatePopupOpen] = useState(false);
  const [popupId, setPopupId] = useState('');

  const [search, setSearch] = useState('');
  useEffect(() => {
    getData();
  }, [])

  const getData = () => {
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    sess_get('admin/console/template/sms', session_token)
      .then(res => { setData(res?.data?.response); setDisplayData(res?.data?.response); })
      .catch(err => console.log(err?.response?.data?.error?.reason));
  }

  useEffect(() => {
    let a;

    if (search === '') {
      a = data;
    } else {
      a = data.filter(e => e.sms_type.toLowerCase().includes(search.toLowerCase()));
    }
    setDisplayData(a);
  }, [search]);



  return <div style={{ width: '800px', margin: '50px auto' }}>
    <h1 style={{ marginBottom: '30px' }}>SMS Templates</h1>
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', margin: '20px 10px' }}>
      <input
        onChange={(e) => setSearch(e.target.value)}
        value={search}
        placeholder="Search ..."
      />
      <button className="btn btn-primary" onClick={() => setIsCreatePopupOpen(true)}>Create New</button>
      <CreatePopup open={isCreatePopupOpen} close={() => { setIsCreatePopupOpen(false); getData(); }} className="btn btn-primary" />
    </div>
    <table>
      <tr>
        <th>SMS type</th>
        <th>Created By</th>
        <th>Created At</th>
        <th>Action</th>

      </tr>
      {

        displayData.map(item => (
          <tr key={item._id}>
            <td>{item.sms_type}</td>
            <td>{item.created_by}</td>
            <td>{moment(item.created_at).format('DD-MM-YYYY')}</td>
            <td style={{ display: 'flex' }}>
              <FiEdit2 style={{ marginRight: '10px', cursor: 'pointer' }} onClick={() => { setIsEditPopupOpen(true); setPopupId(item._id) }} />
              <AiFillDelete style={{ marginRight: '10px', cursor: 'pointer' }} onClick={() => { setIsDeletePopupOpen(true); setPopupId(item._id) }} />
            </td>
          </tr>
        ))
      }
    </table>
    <EditPopup open={isEditPopupOpen} close={() => { setIsEditPopupOpen(false); }} className="btn btn-primary" id={popupId} />
    <DeletePopup open={isDeletePopupOpen} close={() => { setIsDeletePopupOpen(false); }} className="btn btn-primary" id={popupId} />
  </div>
}